import React, { useState, useEffect } from 'react';
import { Pagination } from "rbx";

const PaginationCustom = (props) => {
  const { items, onChangePage, initialPage = 1, pageSize = process.env.REACT_APP_PAGE_SIZE } = props;
  const [pager, setPager] = useState({});

  useEffect(()=>{
    if (items && items.length)
      setPage(initialPage);
  },[items]);

  const setPage = (page) => {
    if (page < 1 || page > pager.totalPages)
      return;

    // get new pager object for specified page
    const pagerTemp = getPager(items.length, page);

    // get new page of items from items array
    const pageOfItems = items.slice(pagerTemp.startIndex, pagerTemp.endIndex + 1);

    // update state
    setPager(pagerTemp);

    // call change page function in parent component
    onChangePage(pageOfItems);
  }

  const getPager = (totalItems, currentPage) => {
      // default to first page
      currentPage = currentPage || 1;

      // calculate total pages
      let totalPages = Math.ceil(totalItems / pageSize);

      let startPage, endPage;
      startPage = 1;
      endPage = totalPages;
/*
      if (totalPages <= 10) {
          // less than 10 total pages so show all
          startPage = 1;
          endPage = totalPages;
      } else {
          // more than 10 total pages so calculate start and end pages
          if (currentPage <= 6) {
              startPage = 1;
              endPage = totalPages;
          } else if (currentPage + 4 >= totalPages) {
              startPage = totalPages - 9;
              endPage = totalPages;
          } else {
              startPage = currentPage - 5;
              endPage = currentPage + 4;
          }
      }
*/
      // calculate start and end item indexes
      let startIndex = (currentPage - 1) * pageSize;
      let endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

      // create an array of pages to ng-repeat in the pager control
      let pages = [...Array((endPage + 1) - startPage).keys()].map(i => startPage + i);

      // return object with all pager properties required by the view
      return {
          totalItems: totalItems,
          currentPage: currentPage,
          pageSize: pageSize,
          totalPages: totalPages,
          startPage: startPage,
          endPage: endPage,
          startIndex: startIndex,
          endIndex: endIndex,
          pages: pages
      };
  }

  return (
    <>
      {
        (pager.pages && pager.pages.length > 1) ?
          <Pagination align="right" size="small" >
            <Pagination.List style={{listStyle: 'none'}}>
              { 
                (pager.currentPage === 1) ? 
                <Pagination.Link align="previous" disabled>Anterior</Pagination.Link> : 
                <Pagination.Link align="previous" onClick={()=>setPage(pager.currentPage - 1)}>Anterior</Pagination.Link>
              }
              {
                (pager.currentPage <= 2) ? '' : 
                <>
                  <Pagination.Link onClick={()=>setPage(pager.startPage)}>{pager.startPage}</Pagination.Link>
                  <Pagination.Ellipsis />
                </>
              }
              { (pager.currentPage === 1) ? '' : <Pagination.Link onClick={()=>setPage(pager.currentPage-1)}>{pager.currentPage-1}</Pagination.Link> }
              <Pagination.Link current>{pager.currentPage}</Pagination.Link>
              { (pager.currentPage === pager.totalPages) ? '' : <Pagination.Link onClick={()=>setPage(pager.currentPage+1)}>{pager.currentPage+1}</Pagination.Link> }
              {
                (pager.currentPage >= pager.totalPages-1) ? '' :
                <>
                  <Pagination.Ellipsis />
                  <Pagination.Link onClick={()=>setPage(pager.endPage)}>{pager.endPage}</Pagination.Link>
                </>
              }
              { 
                (pager.currentPage === pager.totalPages) ? 
                <Pagination.Link align="next" disabled>Próxima</Pagination.Link> : 
                <Pagination.Link align="next" onClick={()=>setPage(pager.currentPage + 1)}>Próxima</Pagination.Link>
              }
            </Pagination.List>
          </Pagination> :
          ''
      }
    </>
  )

}

export default PaginationCustom;

